export const copyText = (text: string): void => {
	const textarea = document.createElement("textarea");
	document.body.appendChild(textarea);
	textarea.value = text;
	textarea.select();
	document.execCommand("copy");
	textarea.remove();
};
